import { Apartment, apartmentSchema } from "@boark/shared/types/apartment";
import { ApartmentCreate } from "@boark/shared/types/apartment-create";
import { ApartmentUpdate } from "@boark/shared/types/apartment-update";
import {
  ApartmentWithHoldingsAndLeasesAndSublets,
  apartmentWithHoldingsAndLeasesAndSubletsSchema,
} from "@boark/shared/types/apartment-with-holdings-and-leases-and-sublets";
import * as z from "zod";

import {
  deleteRequest,
  getRequest,
  postRequest,
  putRequest,
} from "../utils/request";

const API_BASE_URL = process.env.API_BASE_URL || "/api";

export async function getApartments(): Promise<
  ApartmentWithHoldingsAndLeasesAndSublets[]
> {
  return await getRequest(
    `${API_BASE_URL}/apartment`,
    z.array(apartmentWithHoldingsAndLeasesAndSubletsSchema),
  );
}

export async function getApartment(
  id: string,
): Promise<ApartmentWithHoldingsAndLeasesAndSublets> {
  return await getRequest(
    `${API_BASE_URL}/apartment/${id}`,
    apartmentWithHoldingsAndLeasesAndSubletsSchema,
  );
}

export async function createApartment(
  apartment: ApartmentCreate,
): Promise<Apartment> {
  return await postRequest(
    `${API_BASE_URL}/apartment`,
    apartment,
    apartmentSchema,
  );
}

export async function updateApartment(
  id: string,
  apartment: ApartmentUpdate,
): Promise<Apartment> {
  return await putRequest(
    `${API_BASE_URL}/apartment/${id}`,
    apartment,
    apartmentSchema,
  );
}

export async function deleteApartment(id: string): Promise<void> {
  return await deleteRequest(`${API_BASE_URL}/apartment/${id}`);
}

export function formatApartmentLabel(apartment: Apartment): string {
  return `#${apartment.index} - ${apartment.streetNumber}:${apartment.apartmentNumber} (${apartment.objectNumber})`;
}

export function formatApartment(
  apartment: Pick<
    Apartment,
    "index" | "streetNumber" | "apartmentNumber" | "objectNumber"
  >,
): string {
  return `#${apartment.index} - ${apartment.streetNumber}:${apartment.apartmentNumber} (${apartment.objectNumber})`;
}
